// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f46fbc09","667":"fd802950","977":"638442f8"}[chunkId] + ".chunk.js";
};